"use strict";

var _regeneratorRuntime = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistryApi = void 0;

var node_fetch_1 = require("node-fetch");

var config_1 = require("../config/config");

var utils_1 = require("../utils");

var version = require('../../package.json').version;

var RegistryApi = /*#__PURE__*/function () {
  function RegistryApi(accessTokens, region) {
    _classCallCheck(this, RegistryApi);

    this.accessTokens = accessTokens;
    this.region = region;
  }

  _createClass(RegistryApi, [{
    key: "accessToken",
    get: function get() {
      return utils_1.isNotEmptyObject(this.accessTokens) && this.accessTokens[this.region];
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl() {
      var region = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config_1.DEFAULT_REGION;
      return "https://api.".concat(config_1.DOMAINS[region], "/registry");
    }
  }, {
    key: "setAccessTokens",
    value: function setAccessTokens(accessTokens) {
      this.accessTokens = accessTokens;
      return this;
    }
  }, {
    key: "request",
    value: function request() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var region = arguments.length > 2 ? arguments[2] : undefined;

      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var currentCommand, redoclyEnv, headers, response, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentCommand = typeof process !== 'undefined' ? ((_a = process.env) === null || _a === void 0 ? void 0 : _a.REDOCLY_CLI_COMMAND) || '' : '';
                redoclyEnv = typeof process !== 'undefined' ? ((_b = process.env) === null || _b === void 0 ? void 0 : _b.REDOCLY_ENVIRONMENT) || '' : '';
                headers = Object.assign({}, options.headers || {}, {
                  'x-redocly-cli-version': version,
                  'user-agent': "redocly-cli / ".concat(version, " ").concat(currentCommand, " ").concat(redoclyEnv)
                });

                if (headers.hasOwnProperty('authorization')) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Unauthorized');

              case 5:
                _context.next = 7;
                return node_fetch_1.default("".concat(this.getBaseUrl(region)).concat(path), Object.assign({}, options, {
                  headers: headers
                }));

              case 7:
                response = _context.sent;

                if (!(response.status === 401)) {
                  _context.next = 10;
                  break;
                }

                throw new Error('Unauthorized');

              case 10:
                if (!(response.status === 404)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 13;
                return response.json();

              case 13:
                body = _context.sent;
                throw new Error(body.code);

              case 15:
                return _context.abrupt("return", response);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "authStatus",
    value: function authStatus(accessToken, region) {
      var verbose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.request('', {
                  headers: {
                    authorization: accessToken
                  }
                }, region);

              case 3:
                response = _context2.sent;
                _context2.next = 6;
                return response.json();

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                if (verbose) {
                  console.log(_context2.t0);
                }

                throw _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));
    }
  }, {
    key: "prepareFileUpload",
    value: function prepareFileUpload(_ref) {
      var organizationId = _ref.organizationId,
          name = _ref.name,
          version = _ref.version,
          filesHash = _ref.filesHash,
          filename = _ref.filename,
          isUpsert = _ref.isUpsert;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.request("/".concat(organizationId, "/").concat(name, "/").concat(version, "/prepare-file-upload"), {
                  method: 'POST',
                  headers: {
                    'content-type': 'application/json',
                    authorization: this.accessToken
                  },
                  body: JSON.stringify({
                    filesHash: filesHash,
                    filename: filename,
                    isUpsert: isUpsert
                  })
                }, this.region);

              case 2:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", response.json());

              case 5:
                throw new Error('Could not prepare file upload');

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "pushApi",
    value: function pushApi(_ref2) {
      var organizationId = _ref2.organizationId,
          name = _ref2.name,
          version = _ref2.version,
          rootFilePath = _ref2.rootFilePath,
          filePaths = _ref2.filePaths,
          branch = _ref2.branch,
          isUpsert = _ref2.isUpsert,
          isPublic = _ref2.isPublic,
          batchId = _ref2.batchId,
          batchSize = _ref2.batchSize;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.request("/".concat(organizationId, "/").concat(name, "/").concat(version), {
                  method: 'PUT',
                  headers: {
                    'content-type': 'application/json',
                    authorization: this.accessToken
                  },
                  body: JSON.stringify({
                    rootFilePath: rootFilePath,
                    filePaths: filePaths,
                    branch: branch,
                    isUpsert: isUpsert,
                    isPublic: isPublic,
                    batchId: batchId,
                    batchSize: batchSize
                  })
                }, this.region);

              case 2:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                throw new Error('Could not push api');

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return RegistryApi;
}();

exports.RegistryApi = RegistryApi;